import { EmergencyHomeFilled } from '@interhyp/platform-icons';
import _ from 'classnames';
import React, { useEffect, useState } from 'react';
import NumberFormat from 'react-number-format';
import { ErrorTooltip } from "./components/ErrorTooltip.js";
import { Locales } from "../../helper/Locales.js";
import { useEventCallback } from "../../helper/hooks/useEventCallback.js";
import styles from "./InlineInput.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function InlineNumberInput({
  value,
  error,
  suffix,
  locale = 'de',
  format,
  onChange,
  errorTooltipOffset,
  maxDigitCount = Infinity,
  minInputWidth,
  maxInputWidth,
  className,
  disabled
}) {
  const formatConfig = Locales[locale];
  const suffixValue = suffix ? formatConfig.suffix[suffix] : undefined;
  const suffixWidth = suffixValue?.length ?? 0;

  // show the tooltip icon
  const showTooltip = !!error;
  // open the tooltip itself
  const [openTooltip, setOpenTooltip] = useState(false);
  const [inputWith, setInputWidth] = useState(0);

  // The max formatted input value length
  const maxInputWidthAndSuffix = maxInputWidth === undefined ? Infinity : maxInputWidth + suffixWidth;

  // The min formatted input value length
  const minInputWidthAndSuffix = minInputWidth === undefined ? -Infinity : minInputWidth + suffixWidth;
  useEffect(() => {
    if (showTooltip) {
      setOpenTooltip(true);
    }
  }, [showTooltip]);
  const handleOnValueChange = useEventCallback((values, sourceInfo) => {
    format?.onValueChange?.(values, sourceInfo);
    onChange?.(values, sourceInfo);
    setInputWidth(values.formattedValue.length);
  }, [format, onChange]);
  const formatProps = {
    ...(suffix ? {
      suffix: suffixValue,
      thousandSeparator: formatConfig.thousandSeparator,
      decimalSeparator: formatConfig.decimalSeparator,
      decimalScale: 2,
      isNumericString: true
    } : {}),
    ...format,
    onValueChange: handleOnValueChange
  };
  const [inputRef, setInputRef] = useState(null);
  useEffect(() => {
    if (inputRef?.value) {
      // hack to get the initial formatted value from NumberFormat
      setInputWidth(inputRef.value.length);
    }
  }, [inputRef]);
  return /*#__PURE__*/_jsxs("span", {
    className: _(className, styles.wrapper, {
      [styles.showTooltip]: showTooltip
    }),
    children: [showTooltip && /*#__PURE__*/_jsx(ErrorTooltip, {
      icon: EmergencyHomeFilled,
      open: openTooltip,
      onOpenChange: setOpenTooltip,
      content: error,
      offsetY: errorTooltipOffset
    }), /*#__PURE__*/_jsx(NumberFormat, {
      ...formatProps,
      disabled: disabled,
      value: value,
      isAllowed: ({
        floatValue
      }) => {
        return (floatValue ?? 0).toString().length <= maxDigitCount;
      },
      className: styles.input,
      getInputRef: setInputRef,
      style: {
        width: `${Math.max(minInputWidthAndSuffix, Math.min(maxInputWidthAndSuffix, inputWith))}ch`
      }
    })]
  });
}